import { addDays, format } from "date-fns";
const buildHotelDetailURL = (args, hotel, queryString)=>{
    const hotelDetailsURL = hotel?.hotelDetailsURL || '';
    if (hotelDetailsURL) {
        const url = new URL(hotelDetailsURL);
        const pathname = url.pathname;
        const search = url.search;
        return `${pathname}${search}`;
    }
    const isExpressDeal = 'SOPQ' === hotel.hotelType;
    const hotetIdParams = isExpressDeal ? `express/${hotel.location?.cityId}/${hotel.pclnId}` : hotel.hotelId;
    let baseURL = `/relax/at/${hotetIdParams}`;
    if (args?.['check-in'] && args?.['check-out']) baseURL += `/from/${args?.['check-in']}/to/${args?.['check-out']}`;
    else if (isExpressDeal) {
        const today = new Date();
        const tomorrow = addDays(today, 1);
        const defaultCheckIn = format(today, 'yyyyMMdd');
        const defaultCheckOut = format(tomorrow, 'yyyyMMdd');
        baseURL += `/from/${defaultCheckIn}/to/${defaultCheckOut}`;
    }
    if (args?.rooms) baseURL += `/rooms/${args?.rooms}`;
    if (args?.['adult-occ']) baseURL += `/adults/${args?.['adult-occ']}`;
    if (args?.['child-occ']) {
        const childOcc = args?.['child-occ'];
        const childPathParams = childOcc.split(',').reduce((res, child)=>{
            const age = child?.split('-')?.[1];
            if (age) res.push(age);
            return res;
        }, [])?.join(',');
        if (childPathParams) baseURL += `/children/${childPathParams}`;
    }
    return `${baseURL}${queryString}`;
};
export { buildHotelDetailURL };
